import { render, staticRenderFns } from "./LayoutAuth.vue?vue&type=template&id=0c8d03d0&scoped=true"
import script from "./LayoutAuth.vue?vue&type=script&lang=js"
export * from "./LayoutAuth.vue?vue&type=script&lang=js"
import style0 from "./LayoutAuth.vue?vue&type=style&index=0&id=0c8d03d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8d03d0",
  null
  
)

export default component.exports